import { translateStatic } from '../translations';

/**
 * @type {{
 *   id: string;
 *   name: string;
 *   description: string;
 *   img: string;
 *   amountOfMessages: string;
 *   price: number;
 * }[]}
 */
export const bundles = [
  {
    id: 'lover_boy',
    name: translateStatic('plans:plans.plan_name_1'),
    description: 'Unlocks extra 2k messages',
    img: '/addons/anime1.png',
    amountOfMessages: '2k',
    price: 11,
  },
  {
    id: 'lover_man',
    name: translateStatic('plans:plans.plan_name_2'),
    description: 'Unlocks extra 5k messages',
    img: '/addons/anime2.png',
    amountOfMessages: '5k',
    price: 27,
  },
  {
    id: 'true_love',
    name: translateStatic('plans:plans.plan_name_3'),
    description: 'Unlocks extra 10k messages',
    img: '/addons/anime3.png',
    amountOfMessages: '10k',
    price: 50,
  },
];

export const cryptoBundles = [
  {
    id: 'lover_man',
    name: 'Essential',
    description: '2k messages',
    img: '/addons/anime2.png',
    amountOfMessages: '2k',
    price: 12,
    link: 'https://pay.radom.network/pay/729a146b-21c3-468c-8071-d029cc099b1e',
  },
  {
    id: 'standard',
    name: 'Standard',
    description: '3k messages + 400 images + 25 private girls',
    img: '/addons/anime1.png',
    amountOfMessages: '3k',
    price: 24,
    link: 'https://pay.radom.network/pay/d3241348-2d82-41fe-99c4-a8362943d299',
  },
  {
    id: 'all',
    name: 'Deluxe',
    description: '7k messages + 1k images + 100 private girls',
    img: '/addons/anime3.png',
    amountOfMessages: '12k',
    price: 49,
    link: 'https://pay.radom.com/pay/d7081cdc-185e-4d67-b464-27bcee9fc6fa',
  },
];
